import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Modal from "~/js/common/modal";
import HeaderMenu from "./headerMenu";
import Selector from "./selector";
import Tooltip from "~/js/common/tooltip";
import _each from "lodash/each";
import _filter from "lodash/filter";
import _without from "lodash/without";
import _compact from "lodash/compact";
export default class ECSearchMain {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      } else if (mutation.type === "setSearchOptionItem") {
        this.updateOptions();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.modal = new Modal();
    
    this.headerMenu = new HeaderMenu();
    this.selector = new Selector();
    this.tooltip = new Tooltip();
    store.dispatch("init");

    this.setupOptions();
    this.setupOptionCategory();
    this.setupOptionItems();
    ///this.setupOptionAll();
    this.setupClear();
    this.setupFocusEvent();
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }

  //focusイベント
  setupFocusEvent() {
    const optionswraps = document.querySelectorAll(".js-brand-option, .js-item-option, .js-color-option");
    _each(optionswraps, (optionswrap, index) => {
      const title = optionswrap.querySelector(".js-searchoptions");
      let _options = title.getAttribute("data-target");
      let _optionsDom = document.querySelector(_options);

      _optionsDom.addEventListener(
        "keydown",
        function (event) {
          // ESCキーが押された時
          if (event.key === "Escape") {
            this.closeAllOptions();
          }
        }.bind(this)
      );
    });
  }

  // 選択肢表示の制御
  setupOptions() {
    const titles = document.querySelectorAll(".js-searchoptions");
    _each(titles, (title, index) => {
      title.addEventListener("click", (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const _options = target.getAttribute("data-target");

        if (_options) {
          this.closeAllOptions(_options);
          const _optionsDom = document.querySelector(_options);
          // オプションが開いている場合は閉じる
          const _categories = document.querySelectorAll(".js-option-category");
          _each(_categories, (category) => {
            let _target = category.getAttribute("data-category");
            let _targetDom = document.querySelector(_target);
            if (_target && _targetDom) {
              _targetDom.classList.remove("open");
            }
          });
          let result = _optionsDom.classList.toggle("active");
          // 開いているSelectBoxのスタイルを変更する
          if (result) {
            target.classList.add("open");
          } else {
            target.classList.remove("open");
          }
          if (_optionsDom.classList.contains("active")) {
            _optionsDom.focus();
          } else {
            title.focus();
          }
        }
      });
    });
  }

  closeAllOptions(exclude) {
    const titles = document.querySelectorAll(".js-searchoptions");
    _each(titles, (title, index) => {
      const _options = title.getAttribute("data-target");
      if (_options === exclude) {
        return;
      }
      if (_options) {
        title.classList.remove("open");
        const _optionsDom = document.querySelector(_options);
        _optionsDom.classList.remove("active");
      }
    });
  }

  //カテゴリの開閉を制御
  setupOptionCategory() {
    const categories = document.querySelectorAll(".js-option-category");
    _each(categories, (category) => {
      category.addEventListener("click", (event) => {
        const _target = category.getAttribute("data-category");
        const targetDOM = document.querySelector(_target);
        if (targetDOM) {
          targetDOM.classList.toggle("open");
        }
      });
    });
  }

  // セレクトオプション選択時の制御
  setupOptionItems() {
    const options = document.querySelectorAll(".js-option");
    const closes = document.querySelectorAll(".js-closeoption");
    if (options) {
      _each(options, (option, index) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();
          // ◯◯すべて があるときの処理
          if (option.classList.contains("js-option-all")) {
            this.selectGroupAll(option);
          } else {
            // ◯◯すべて が選択されている場合は、それを解除する
            this.clearGroupAll(option);
          }
          this.execOptionItem(option);

          /**
           * TODO: kanehori add code
           * カテゴリ選択後に閉じられないためサブミットできないバグ対応
           *
           * 複数選択仕様への調整に伴い、
           * setupOptions 内で都度閉じるように調整
           */
          //if (event.target.closest(".open")) {
          //  event.target.closest(".open").classList.remove("open");
          //}
        });
      });
    }
    if (closes) {
      _each(closes, (close, index) => {
        close.addEventListener("click", (event) => {
          event.preventDefault();
          this.closeAllOptions();
        });
      });
    }
  }

  /**
   * ◯◯すべて（グループオール）が選択されたときの処理
   * @param target
   */
  selectGroupAll(target) {
    const groupOptions = target.parentNode.querySelectorAll(".js-option");
    let nodeList = _filter(groupOptions, (option) => {
      return !option.classList.contains("js-option-all");
    });
    // グループ内の選択肢をすべて解除
    this.clearOptionInGroup(nodeList);
  }

  clearOptionInGroup(nodeList) {
    nodeList.forEach((node) => {
      if (node.classList.contains("active")) {
        node.classList.remove("active");
        // ここでactiveなグループのstoreの値を更新する
        store.dispatch("setSearchOptionItem", {
          target: node.getAttribute("data-target"),
          label: node.getAttribute("data-label"),
          value: node.getAttribute("data-value")
        });
      }
    });
  }

  /**
   * グループオール選択肢の選択を解除
   * @param target
   */
  clearGroupAll(target) {
    let allName = target.getAttribute("data-groupall");
    let groupAll = document.querySelector(allName);
    if (groupAll) {
      if (groupAll.classList.contains("active")) {
        groupAll.classList.remove("active");
        store.dispatch("setSearchOptionItem", {
          target: groupAll.getAttribute("data-target"),
          label: groupAll.getAttribute("data-label"),
          value: groupAll.getAttribute("data-value")
        });
      }
    }
  }

  /**
   * オプション選択
   * @param option
   * @param clearOthers 真であれば他の選択肢をすべて解除
   */
  execOptionItem(option, clearOthers = false) {
    const target = option.getAttribute("data-target");
    const value = option.getAttribute("data-value");
    const label = option.getAttribute("data-label");
    const targetDom = document.querySelector(target);
    const optionsTitle = targetDom.querySelector(".js-searchoptions");
    const defaultOption = targetDom.querySelector(".js-default");

    if (clearOthers) {
      this.clearOptionItem(targetDom);
    }

    store.dispatch("setSearchOptionItem", {
      target: target,
      label: label,
      value: value
    });
    if (value === "") {
      // すべて 選択時
      this.clearOptionItem(targetDom);
    } else {
      // 「すべて」選択を解除
      if (defaultOption) {
        defaultOption.classList.remove("active");
      }
    }
    if (option.classList.contains("active")) {
      option.classList.remove("active");
      // すべてのオプション選択解除時には「すべて」を選択状態に
      const options = targetDom.querySelectorAll(".js-option");
      let all = true;
      _each(options, (option) => {
        if (option.classList.contains("active")) {
          all = false;
        }
      });
      if (all) {
        defaultOption.classList.add("active");
      }
    } else {
      option.classList.add("active");
    }

    // optionsTitle.focus();
    // オプション選択時に閉じる仕様を外す
    /// this.closeAllOptions();
  }

  /**
   * オプション選択解除
   * @param targetDom
   */
  clearOptionItem(targetDom) {
    let brothers = targetDom.querySelectorAll(".js-option"); //option.parentNode.children;
    // 選択されたノードの解除機能
    if (brothers) {
      _each(brothers, (brother) => {
        brother.classList.remove("active");
      });
    }
  }

  /**
   * クリアボタン押下時
   */
  setupClear() {
    const clearbutton = document.querySelector(".js-clear");
    if (clearbutton) {
      clearbutton.addEventListener("click", (event) => {
        const defaults = document.querySelectorAll(".js-default");
        _each(defaults, (defaultOption) => {
          this.execOptionItem(defaultOption, true);
        });
      });
    }
  }

  /**
   * オプション選択後の表示・データ更新
   */
  updateOptions() {
    const optionItem = store.getters["optionItem"]();
    let _target = document.querySelector(optionItem.target);
    if (_target) {
      let label = _target.querySelector(".js-searchoptions .js-label");
      let input = _target.querySelector(".js-input");
      const defaultDom = _target.querySelector(".js-default");
      if (optionItem.value === "") {
        // 空の場合 = 「すべて」を選択
        label.innerHTML = optionItem.label;
        input.value = "";
        return;
      }
      // 既存のデータを確認
      let labels = _compact(label.innerHTML.split(","));
      let inputDatas = _compact(input.value.split(","));
      let exist = false;
      _each(inputDatas, (_input, index) => {
        if (_input === optionItem.value || _input === "") {
          // すでに選択済み項目を選択した。 もしくは 「すべて」の項目は削除
          inputDatas[index] = "";
          labels[index] = "";
          exist = true;
        }
      });
      if (exist) {
        // 選択済みの削除は↑で実行済み
      } else {
        if (inputDatas.length === 0) {
          labels = [];
        }
        // 新規選択
        labels.push(optionItem.label);
        inputDatas.push(optionItem.value);
      }
      labels = _compact(labels, "");
      inputDatas = _compact(inputDatas, "");
      // カラー表示用 色玉表記をあきらめるか、、
      //if (optionItem.target === ".js-color-option") {
      //  label.innerHTML = labels.toString(); //labels.toString(); //optionItem.label;
      //  input.value = inputDatas.toString(); // optionItem.value;
      //} else {

      let htmlLabels = labels.map(label => {
        if (label.includes("<span")) {
          return label;
        } else {
          return `<span class="label">${label}</span>`;
        }
      }).join(',');
      label.innerHTML = htmlLabels;

      //label.innerHTML = labels.toString(); //labels.toString(); //optionItem.label;
      input.value = inputDatas.toString(); // optionItem.value;
      //}

      // 入力内容がカラだった場合は「すべて」を表示
      if (inputDatas.length === 0) {
        label.innerHTML = defaultDom.getAttribute("data-label") || "";
        input.value = "";
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ECSearchMain();
});